<template>
  <div>
    <ul
      class="dashboard__gallery-wrap layout__component-container layout--plain-list layout--padding-top-none layout--padding-bottom-none"
      v-if="!empty"
    >
      <li
        v-for="timer in timerList"
        :key="timer.widget.id"
        class="dashboard__gallery-item"
      >
        <GalleryItem :timer="timer" />
      </li>
    </ul>
    <ul
      class="dashboard__gallery-wrap layout__component-container layout--plain-list"
      v-if="empty"
    >
      <li
        v-if="empty"
        class="dashboard__gallery-item dashboard__gallery-item--dark"
      >
        <GalleryItem empty />
      </li>
    </ul>
  </div>
</template>

<script>
import GalleryItem from "./GalleryItem";

export default {
  name: "table-gallery",
  props: {
    timerList: Array,
    empty: Boolean,
  },
  components: { GalleryItem },
};
</script>

<style></style>
